







import { Component, Vue } from 'vue-property-decorator'
import Cadastro from '@/components/authentication/Cadastro.vue'
import NavbarBlocked from '@/components/navbar/NavbarBlocked.vue'


@Component({
  components: {
    Cadastro,
    NavbarBlocked
  },
  })
export default class Registro extends Vue {}
